import React from 'react'
import { FieldLabel } from '../form/index'
import AirlineSearchSelect from './AirlineSearchSelect'

const AirlineSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={AirlineSearchSelect} />
)

export default AirlineSearchSelectField
